module.exports = __webpack_public_path__ + "img/loading.79dab2cd.png";